
import styles from "./styles.module.scss"
import { AssessmentStatistics, AssessmentTableSection, Breadcrumbs } from "components";
import { useParams } from "react-router-dom";
import { useReviewTalentsSummary, useManageJobs } from "hooks";
import { useState, useEffect } from "react";
import { Spinner } from "components/loader";
import { EmptyTable } from "components/empty-table";
import { emptyReport2 } from "assets";

const ReviewTalentsUI = () => {
  const { id: assessmentId } = useParams<{ id: string }>();
  const { summary, isLoading: summaryLoading, error: summaryError } = useReviewTalentsSummary(assessmentId);
  
  // Fetch all jobs to populate dropdown
  const { jobs, isLoading: jobsLoading } = useManageJobs({ pageSize: 100 });
  
  // Find current job title from the jobs list using assessmentId
  const [currentJobTitle, setCurrentJobTitle] = useState<string>("");
  
  const currentJob = jobs.find(job =>
    job.assessment_id === assessmentId || job.id?.toString() === assessmentId
  );

  useEffect(() => {
    if (jobs.length > 0 && assessmentId) {
      setCurrentJobTitle(currentJob?.title || "Assessment");
    }
  }, [jobs, assessmentId, currentJob]);

  // Show loading state
  if (summaryLoading || jobsLoading) {
    return (
      <div className={styles.container}>
        <section className={`md:px-9 px-4 md:py-5 py-6 ${styles.mainSection}`}>
          <div className="flex justify-center items-center py-20">
            <Spinner />
          </div>
        </section>
      </div>
    );
  }

  // Show error state if summary fails
  if (summaryError && !summary) {
    return (
      <div className={styles.container}>
        <section className={`md:px-9 px-4 md:py-5 py-6 ${styles.mainSection}`}>
          <Breadcrumbs />
          <div className="flex justify-center items-center py-20">
            <EmptyTable 
              image={emptyReport2} 
              text="Unable to load assessment data. Please try again later." 
            />
          </div>
        </section>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <section className={`md:px-9 px-4 md:py-5 py-6 ${styles.mainSection}`}>
        <Breadcrumbs />
        <AssessmentStatistics
          jobTitle={currentJobTitle || "Assessment"}
          totalTalents={summary?.total_talents || 0}
          averageScore={summary?.average_score || 0}
          interviewReady={summary?.bucket_summary?.["Interview"]?.count ?? summary?.interview_ready ?? 0}
          probeFurther={summary?.bucket_summary?.["Probe further"]?.count ?? summary?.probe_further ?? 0}
          rejected={summary?.bucket_summary?.["Reject"]?.count ?? summary?.rejected ?? 0}
          status={summary?.status === "active" ? "Active" : "Inactive"}
          allJobs={jobs}
          currentAssessmentId={assessmentId}
          deadline={summary?.deadline}
        />
        <AssessmentTableSection assessmentId={assessmentId} />
      </section>

    </div>
  )
}

export { ReviewTalentsUI }
